import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { X } from 'lucide-react';
import axios from 'axios';

const API = '/api';

const C = {
  bg: '#FFFCF8', accent: '#C67A5C', text: '#1A1A18',
  muted: '#9A9590', border: '#E8E3DB',
};

export function HealthToolDiscovery() {
  const { authHeaders, user } = useAuth();
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const res = await axios.get(`${API}/health-tools/discovery`, authHeaders());
        if (res.data.prompt) setPrompt(res.data.prompt);
      } catch {}
    })();
  }, [user, authHeaders]);

  const handleDismiss = async () => {
    setDismissed(true);
    if (prompt) {
      try {
        await axios.post(`${API}/health-tools/discovery/dismiss`, { id: prompt.id }, authHeaders());
      } catch {}
    }
  };

  const handlePrimary = () => {
    handleDismiss();
    if (prompt.route) navigate(prompt.route);
  };

  if (!prompt || dismissed) return null;

  return (
    <div
      data-testid={`discovery-prompt-${prompt.id}`}
      style={{
        background: C.bg, borderRadius: 16,
        border: `1px solid ${C.accent}20`,
        padding: '16px 18px', marginBottom: 16,
        position: 'relative',
      }}
    >
      <button
        onClick={handleDismiss}
        data-testid="discovery-prompt-dismiss"
        style={{
          position: 'absolute', top: 10, right: 10,
          background: 'none', border: 'none', cursor: 'pointer', padding: 4,
        }}
      >
        <X style={{ width: 14, height: 14, color: C.muted }} />
      </button>
      <p style={{
        fontFamily: 'var(--font-serif)', fontSize: 16, fontWeight: 400,
        color: C.text, margin: '0 0 6px', paddingRight: 24,
      }}>
        {prompt.title}
      </p>
      <p style={{
        fontSize: 13, color: C.muted, margin: '0 0 14px',
        fontFamily: 'var(--font-sans)', lineHeight: 1.5,
      }}>
        {prompt.text}
      </p>
      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={handlePrimary}
          data-testid="discovery-prompt-primary"
          style={{
            padding: '8px 20px', borderRadius: 20,
            background: C.accent, color: '#FFF', border: 'none',
            fontSize: 13, fontWeight: 500, cursor: 'pointer',
            fontFamily: 'var(--font-sans)',
          }}
        >
          {prompt.primary_action}
        </button>
        {prompt.secondary_action && (
          <button
            onClick={handleDismiss}
            data-testid="discovery-prompt-secondary"
            style={{
              padding: '8px 16px', borderRadius: 20,
              background: 'transparent', color: C.muted, border: `1px solid ${C.border}`,
              fontSize: 13, fontWeight: 500, cursor: 'pointer',
              fontFamily: 'var(--font-sans)',
            }}
          >
            {prompt.secondary_action}
          </button>
        )}
      </div>
    </div>
  );
}
